import { RoutesEnum } from '@ui-core/enums/routes.enum'

const ERRORS = {
    [RoutesEnum.FORBIDDEN]: {
        title: 'Forbidden - 403',
        message: 'You do not have permission to access this resource..',
    },
    [RoutesEnum.ERROR_404]: {
        title: 'Page Not Found - 404',
        message: 'The page you are looking for does not exist.',
    },
}

const HEADER_HEIGHT = 80
const MENU_ITEM_HEIGHT = 38
const MENU_PADDING = 22

export { ERRORS, HEADER_HEIGHT, MENU_ITEM_HEIGHT, MENU_PADDING }
